
import axiosInstance from '../axiosInstance';
import { useEffect, useMemo, useState, useRef } from 'react';
import { FaDownload } from 'react-icons/fa';
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL_All } from '../api';
import * as general from '../libs/general';
import Paging from '../components/Paging';
import ContactOrderVatReview from '../components/orders/ContactOrderVatReview';
import ReconciliationPaymentConfirmModal, { buildPaymentSummary } from '../components/reconciliation/ReconciliationPaymentConfirmModal';
import AdLayout from '../components/AdLayout';
import DataTable from '../components/ui/DataTable';
import { CheckingTicket, LockingTicket } from '../components/tickets/Tickets';
import { fetchReconcilePartnerVatPermissions } from "../libs/customerCreatePermission";

function ContactVatInvoices() {
  const [pageInvoiceData, setPageInvoiceData] = useState({ content: [] });
  const [isLoading, setIsLoading] = useState(false);

  const [contactOrderVatData, setContactOrderVatData] = useState(null);
  const [paymentConfirm, setPaymentConfirm] = useState(null);

  const hasInvoiceRun = useRef(false);

  const [customerCodes, setCustomerCodes] = useState("");
  const [customerVats, setCustomerVats] = useState("");
  const [params, setParams] = useState({});
  const [message, setMessage] = useState("");
  const [partnerVatPerm, setPartnerVatPerm] = useState({
    loaded: false,
    canView: false,
    canCreate: false,
    canEdit: false,
  });

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await axiosInstance.get(`/api/users/all`);
        const list = response.data.map(item => item.customerCode).filter(code => code);
        const uniqueList = [...new Set(list)];
        var joinedCodes = uniqueList.join(',');
        setCustomerCodes(joinedCodes);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCustomers();
    searchInvoices();
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchReconcilePartnerVatPermissions(axiosInstance);
      if (!cancelled) {
        setPartnerVatPerm({
          loaded: true,
          canView: Boolean(p?.canView),
          canCreate: Boolean(p?.canCreate),
          canEdit: Boolean(p?.canEdit),
        });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleSearchChange = (e) => {
    var searchValue = e.target.value;
    searchInvoices({ page: 0, keyword: searchValue });
  };

  const handleRefreshPage = (e) => {
    searchInvoices();
  };

  const searchInvoices = async (filter) => {
    if (window.calling2) return;
    setIsLoading(true);
    window.calling2 = true;
    var params = general.getSession('form_contact_invoice_vat_filter');
    var formData = general.getFormData('#form_contact_invoice_vat_filter');
    Object.assign(params, formData);

    if (!hasInvoiceRun.current) {
      hasInvoiceRun.current = true;
      var oldParams = general.getSession('form_contact_invoice_vat_filter');
      Object.assign(params, oldParams);
      //setSearchQuery(params.keyword);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('form_contact_invoice_vat_filter', params);
    setParams(params);
    window.initializeFilterValue(params);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    setMessage("");
    setPageInvoiceData({ content: [] });
    try {
      var response = await axiosInstance.get('/api/invoices/searchContactInvoices', { params: filteredParams });
      setPageInvoiceData(response.data);
    } catch (error) {
      //setPageData({ content: [] });
      setMessage(error.message);
      console.error(error);
    } finally {
      window.calling2 = false;
    }
    setIsLoading(false);
  }

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchInvoices({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchInvoices({ page: page - 1 });
  };

  const openInvoiceDetail = async (id) => {
    if (!partnerVatPerm.loaded || !partnerVatPerm.canView) {
      toast.warning("Bạn không có quyền xem chi tiết hóa đơn VAT.");
      return;
    }
    setContactOrderVatData({ id: id });
  };

  const handlePaymentConfirm = (item) => {
    if (!partnerVatPerm.loaded || !partnerVatPerm.canEdit) {
      toast.warning("Bạn không có quyền cập nhật đối soát.");
      return;
    }
    setPaymentConfirm(item);
  };

  const handleExportInvoice = async (param) => {
    var requestApi = `${API_URL_All}/api/invoices/downloadContactInvoiceVat?id=${param.id}`;
    var fileName = `Doi_soat_doi_tac_${param.id}.xlsx`;
    general.downloadFile(requestApi, fileName);
  };

  return (
    <div>
      <AdLayout>
        <div className="table-responsive web-table">
          <div className="tab-container">
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button className="nav-link"><Link to="/don-hang-vat-doi-tac">Đối tác: Đơn hàng VAT</Link></button>
                <button className="nav-link active">Đối tác: Hóa đơn VAT</button>
              </div>
            </nav>
            <div className="tab-content bg-white" id="nav-tabContent">
              <div className="tab-pane fade show active" id="pane-02" role="tabpanel" aria-labelledby="nav-profile-tab">

                <div className="container-fluid pt-2">
                  <div className="text-start mb-2 normal-form">
                    <div className="row">
                      <div className="col-md-5">
                        <form id="form_contact_invoice_vat_filter">
                          <input type="hidden" name="types" value="Vat" />
                          <div className="row">
                            <div className="col-md-7 height-46">
                              <div className="row">
                                <label className="form-label col-form-label col-md-4">Tìm kiếm</label>
                                <div className="col-md-8">
                                  <input className="form-control" type="text" name="keyword" placeholder="Nhập từ khóa..." autoComplete="off" value={params.keyword} onChange={(e) => handleSearchChange(e)} />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-5">
                              <div>
                                <button onClick={(event) => searchInvoices({ page: 0 })} type="button" className="btn btn-info btn-sm me-2 " >
                                  Tìm kiếm
                                </button>
                              </div>
                            </div>
                          </div>

                        </form>
                      </div>

                      <div className="col-4 col-md-1 p-0">

                      </div>

                    </div>

                  </div>
                </div>

                <section className="p-1">
                  <DataTable maxHeight="calc(100vh - 220px)" className="table-normal" data-loading={isLoading}>
                    <table className="table table-striped table-bordered border-normal">
                      <thead className="table-primary">
                        <tr>
                          <th width="30px" className="sticky text-center">STT</th>
                          <th className="text-center"><span>Ngày đối soát</span></th>
                          <th className="text-center">
                            <span>Mã đối tác</span>

                          </th>
                          <th className="text-start"><span>Nội dung</span></th>
                          <th className="text-center"><span>Số đơn</span></th>
                          <th className="text-center"><span data-note="">Tổng phí ĐT</span></th>
                          <th><span>Trạng thái</span></th>
                          <th><span>Người xử lý</span></th>
                          <th><span>Actions</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        {pageInvoiceData.page && pageInvoiceData.page.content && pageInvoiceData.page.content.map((item, index) => (
                          <tr key={index}>
                            <td className="sticky text-center" title={`id: ${item.id}`}>{(pageInvoiceData.page.number * pageInvoiceData.page.size) + index + 1}</td>
                            <td className="text-center" title={general.formatTimeShort(item.createdAt)}>{general.formatDate(item.createdAt)}</td>
                            <td className="text-center">{item.contactCode}</td>
                            <td className="text-start">{item.name}</td>
                            <td className="text-center">{item.orderCount}</td>
                            <td className="text-center">{general.formatNumber(item.contactFee)}</td>
                            <td className="text-start">
                              <CheckingTicket checkingId={item.checkingId} checkingName={item.checkingName} />
                              {item.checkingId === 14 && partnerVatPerm.canEdit && (
                                <span>
                                  <span className="btn-sm btn btn-primary ms-2" onClick={(e) => handlePaymentConfirm(item)}>Xác nhận thanh toán</span>
                                </span>
                              )}
                            </td>
                            <td className="text-start mw-200">admin</td>
                            <td className="text-center">
                              <span className="small-btn" title="Xuất file" onClick={(e) => { handleExportInvoice({ id: item.id }) }}><FaDownload /></span>
                              <span className="small-btn" onClick={(e) => { openInvoiceDetail(item.id) }}>xem</span></td>
                          </tr>
                        ))}
                      </tbody>
                      <tbody>
                        {message === '' && pageInvoiceData.page && pageInvoiceData.page.content.length === 0 && (
                          <tr>
                            <td colSpan="11" className="text-center">Không tìm thấy dữ liệu</td>
                          </tr>
                        )}
                        {message !== '' && (
                          <tr>
                            <td colSpan="11" className="text-center">{message}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </DataTable>
                </section>
              </div>
            </div>
          </div>

          <div className="my-1 d-flex justify-content-end align-items-center">
            <Paging
              pageData={pageInvoiceData}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleChangeItemsPerPage}
            />
          </div>

          <input type="hidden" id="editor_lines" value="TMĐT,Line Thường,Line XT" />
          <input type="hidden" id="list_lines" value="TMĐT,Line Thường,Line XT,Line VAT" />
          <input type="hidden" id="list_status" value="Đơn mới,Kho TQ,Xe Về VN,Kho VN,Đang Giao,Đã Nhận" />
          <input type="hidden" id="list_rateStatus" value="Chưa đối soát,Vào phiếu,Đã đối soát" />
          <input type="hidden" id="list_customers" value={customerCodes} />
          <input type="hidden" id="list_vats" value={customerVats} />

          {contactOrderVatData && (
            <ContactOrderVatReview data={contactOrderVatData} handleSearch={handleRefreshPage} canEdit={partnerVatPerm.canEdit} />
          )}

          {paymentConfirm && (
            <ReconciliationPaymentConfirmModal
              show={!!paymentConfirm}
              onHide={() => setPaymentConfirm(null)}
              onSuccess={handleRefreshPage}
              completeApi="/api/invoices/completeContactInvoice"
              payloadBase={{ id: paymentConfirm.id }}
              summary={buildPaymentSummary(paymentConfirm, "partner")}
              accountLabel="Tài khoản chi tiền"
            />
          )}

        </div >
      </AdLayout>

    </div>
  );
}
export default ContactVatInvoices;